import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { load as loadProjectList, loadObject, loadUser } from '../../../reducers/models/project/projectList'
import { faArchive, faPlay } from "@fortawesome/free-solid-svg-icons";
import List from "./List";
import ModalEdit from "./ModalEdit";
import TabBar from "../../../components/ui/TabBar";
import InfoNoData from "../../../components/global/InfoNoData";
import axios from "axios";
import ModalAdd from "../../../components/modal/ModalAdd";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const dispatch = useDispatch()

    const stateProjectList = useSelector((state) => state.projectList);

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 1, name: "Активные", icon: faPlay, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 0, name: "Архив", icon: faArchive, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(1);
    const [list, setList] = useState([]);

    function tabHandler(id_tab) {
        setTabSelected(id_tab)
        if (id_tab === 0) {
            loadList(0);
        }
    }
    //TAB END

    useEffect(() => {
        loadList(1);
    }, []);

    useEffect(() => {
        if (tabSelected === 1) {
            setList(stateProjectList.list.filter(a => a.ID_Status === 1));
        }
        else {
            setList(stateProjectList.list);
        }
    }, [tabSelected, stateProjectList.list]);

    const [log, setLog] = useState([]);
    /****************************START АРХИВНЫЕ*****************************/

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading3 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    function loadList(id_status) {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === id_status) {
                return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
            }
            else {
                return item;
            }
        }))

        //Подгружаем проекты
        if (stateProjectList.listLoaded.filter(a => a.id_status === id_status).length === 0) {
            axios.get('/api_tracker/project/list', { params: { ID_Status: id_status } })
                .then((res) => {
                    if (res.data.Status == 1) {
                        dispatch(loadProjectList({ list: res.data.Data, id_status: id_status }));
                    }
                    else {
                        setLog(res.Error);
                    }

                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading1: false }
                        }
                        else {
                            return item;
                        }
                    }))
                })
                .catch((err) => {

                    setLog('Неизвестная ошибка!');
                    ErrorAdd(err, window.location.href);

                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading1: false }
                        }
                        else {
                            return item;
                        }
                    }))

                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === id_status) {
                    return { ...item, loading1: false }
                }
                else {
                    return item;
                }
            }))
        }
        //Подгружаем связку проект-объект
        if (stateProjectList.listObjectLoaded.filter(a => a.id_status === id_status).length === 0) {
            axios.get('/api_tracker/project/objectList', { params: { ID_Status: id_status } })
                .then((res) => {
                    if (res.data.Status == 1) {
                        dispatch(loadObject({ list: res.data.Data, id_status: id_status }))
                    }
                    else {
                        setLog(res.Error);
                    }
                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading2: false }
                        }
                        else {
                            return item;
                        }
                    }))
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    ErrorAdd(err, window.location.href);

                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading3: false }
                        }
                        else {
                            return item;
                        }
                    }))

                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === id_status) {
                    return { ...item, loading2: false }
                }
                else {
                    return item;
                }
            }))
        }
        //Подгружаем связку проект-пользователь
        if (stateProjectList.listUserLoaded.filter(a => a.id_status === id_status).length === 0) {
            axios.get('/api_tracker/project/userList', { params: { ID_Status: id_status } })
                .then((res) => {
                    if (res.data.Status == 1) {
                        dispatch(loadUser({ list: res.data.Data, id_status: id_status }));
                    }
                    else {
                        setLog(res.Error);
                    }
                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading3: false }
                        }
                        else {
                            return item;
                        }
                    }))
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    ErrorAdd(err, window.location.href);

                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading3: false }
                        }
                        else {
                            return item;
                        }
                    }))

                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === id_status) {
                    return { ...item, loading3: false }
                }
                else {
                    return item;
                }
            }))
        }
    }

    /*****************************END АРХИВНЫЕ******************************/
    /***************************START ДОБАВЛЕНИЕ****************************/
    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalEditShow, setModalEditShow] = useState(false);

    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);
    const [model, setModel] = useState(null);

    //Добавит новый проект
    function addHandler(name) {
        setLoadingAdd(true);
        setLogAdd(null);

        axios.post('/api_tracker/project/add', { ID_Parent: null, Name: name, Description: null, All_Object: true, All_User: true })
            .then((res) => {
                if (res.data.Status === 1) {
                    getNew(res.data.Data);
                }
                else {
                    setLogAdd(res.data.Error);
                    setLoadingAdd(false);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Откроет новый проект в модальном окне
    function getNew(id) {

        axios.get('/api_tracker/project/get', { params: { ID: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setModel(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setLoadingAdd(false);
                }
                else {
                    setLoadingAdd(false);
                    setLogAdd(res.Error);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /****************************END ДОБАВЛЕНИЕ*****************************/

    return (
        <div className='admin_content'>
            {modalAddShow === true && (
                <ModalAdd show={modalAddShow} onHide={() => { setModalAddShow(false); setLogAdd(null) }} title="Добавление проекта" error={logAdd} loading={loadingAdd} updateHandler={addHandler} />
            )}
            {modalEditShow === true && (
                <ModalEdit show={modalEditShow} onHide={() => setModalEditShow(false)} model={stateProjectList.list.filter(a => a.ID === model.ID)[0]} />
            )}
            <div className="mb-20">
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} showFilter={false} setAddShow={setModalAddShow} />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>

                    {tab.loading === true ? (
                        <div className="loader_01 mt-30"></div>
                    ) : (
                        <div style={{ marginTop: '-15px' }}>
                            {list.filter(a => a.ID_Status === tab.id_tab).length === 0 ? (
                                <InfoNoData text="Нет проектов" />
                            ) : (
                                <List key={tab.id_tab} id_tab={tab.id_tab} id_parent={null} list={list} />
                            )}
                        </div>
                    )
                    }

                </div>
            ))}
        </div>
    )
}
export default Index;